<template>
  <div class="main-content-box">
    <bannerEl/>
    <bannerMobileEl/>
    <aboutEL/>
  </div>
</template>

<script>
import bannerEl from "@/views/page/about/banner";
import bannerMobileEl from "@/views/page/about/banner_moblie";
import aboutEL from "@/views/page/about/about";

export default {
  name: "article_edit",
  components:{
    bannerEl,
    bannerMobileEl,
    aboutEL
  },
  data() {
    return {

    }
  },
  computed: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.main-content-box{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}
</style>
